const profile = {
    "LBL_PAGE_TITLE":"Профиль пользователя",
};
export default profile